// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3500) return "static/chunks/3500-ee9ef68bca37fd88.js";
	if (chunkId === 7611) return "static/chunks/1685bfe7-85a93bbcf153e1fa.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5281 ? "a9510dc7" : chunkId) + "." + {"1120":"137cd392c7b706e2","5281":"f67332f2f4029afe","6175":"024394b3f673602e","7714":"21171c335d8c84f1","8556":"062c4efeec65b628"}[chunkId] + ".js";
};